import { MessagePanel } from 'app/components';
import { STATE } from 'app/constants';
import { enableNotifications } from 'app/infrastructure/notifications/index';
import { containerFactory } from 'app/infrastructure/redux';
import { layoutTranslation } from 'app/shell/constants';
import { DevErrorPanel } from 'app/shell/components/dev-error-panel';
import * as React from 'react';
import * as actions from './actions';
import { AppShell } from 'app/shell/app-shell';
import { LayoutProps, LayoutContainerProps } from 'app/shell/types';

import styles from 'app/shell/layout.scss';
import anonymousLayout from './anonymous-layout.scss';
import { withRouter } from 'app/components/enhancers/with-router';
import { Outlet } from 'react-router-dom';

type AnonymousLayoutContainerProps = 
  LayoutContainerProps & 
  typeof actions.actionCreators &
  { router: any; routes: any; anonCtx: string };

/**
 * LayoutComponent performs the first level of application component rendering.
 * Wrapped by only react-router and context providers.
 *
 */
export class AnonymousLayoutComponent extends React.Component<
  AnonymousLayoutContainerProps
  > {
  public static statePath: string = STATE.app;

  public componentWillMount() {
    const { setActiveAnonCtx, locale, changeUserLocale } = this.props;
    setActiveAnonCtx && setActiveAnonCtx(this.props.anonCtx);
    if (!locale) {
      changeUserLocale && changeUserLocale(AppShell.locale);
    }
  }

  public componentDidMount() {
    enableNotifications(null, (this.props as any).dispatch);
  }

  public render() {
    const { messages } = this.props;

    const body =  (
      <div>
        <main>
          <MessagePanel messages={messages} />

          <Outlet />

        </main>
      </div>
    );

    return (
      <div className={`${styles.layout} ${anonymousLayout.layout} anonymous`}>
        <div className={styles.contentWrapper}>
          <DevErrorPanel errors={this.props.errors} />
          {body}
        </div>
      </div>
    );
  }
}

const selectors = {
  anonCtx: (state: any, props: any) =>
    props.router.location.query && props.router.location.query.anonCtx
};

const AnonymousLayoutContainer = containerFactory<LayoutProps>(
  AnonymousLayoutComponent,
  { ...actions.actionCreators },
  selectors,
  layoutTranslation
);

export const AnonymousLayout = props => {
  const WrappedComponent = withRouter(AnonymousLayoutContainer);
  return <WrappedComponent {...props} />;
};
